// Una pregunta de la caracterización según su tipo:
// - unica: opciones como píldoras (se marca una)
// - multiple: casillas en dos columnas con el texto completo debajo del corto; las excluyentes ("Ninguna", "Por ahora no") desmarcan las demás
// - texto: campo de varias líneas con contador
import React from "react";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import { useEstilosInscripcion } from "./estilosInscripcion";
import { alternarOpcion, MAXIMO_TEXTO } from "./caracterizacion";

export default function PreguntaCaracterizacion({ pregunta, respuesta = {}, onCambiar, error }) {
  const classes = useEstilosInscripcion();
  const marcadas = respuesta.opciones || [];
  const marcar = (codigo) => onCambiar({ opciones: alternarOpcion(pregunta, marcadas, codigo) });

  const enunciado = (
    <p className={`${classes.preguntaEnunciado} ${error ? classes.preguntaError : ""}`}>
      {pregunta.nombre}
      {pregunta.obligatoria ? " *" : <span className={classes.preguntaOpcional}> (opcional)</span>}
    </p>
  );

  if (pregunta.tipo === "texto") {
    const texto = respuesta.texto || "";
    return (
      <div>
        {enunciado}
        <TextField
          value={texto}
          onChange={(e) => onCambiar({ texto: e.target.value.slice(0, MAXIMO_TEXTO) })}
          placeholder="Escribe tu respuesta"
          multiline
          rows={2}
          rowsMax={8}
          fullWidth
          error={error}
          helperText={`${texto.length}/${MAXIMO_TEXTO}`}
          FormHelperTextProps={{ className: classes.contador }}
        />
      </div>
    );
  }

  if (pregunta.tipo === "multiple") {
    return (
      <div>
        {enunciado}
        <div className={`${classes.opcionesMultiples} ${error ? classes.opcionesError : ""}`}>
          {pregunta.opciones.map((o) => {
            const marcada = marcadas.includes(o.codigo);
            return (
              <label key={o.codigo} className={`${classes.opcionCasilla} ${marcada ? classes.opcionCasillaMarcada : ""}`}>
                <Checkbox checked={marcada} onChange={() => marcar(o.codigo)} size="small" />
                <span>
                  {o.corto}
                  {o.nombre !== o.corto && <span className={classes.opcionDetalle}>{o.nombre}</span>}
                </span>
              </label>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div>
      {enunciado}
      <div role="radiogroup" className={`${classes.opcionesUnica} ${error ? classes.opcionesError : ""}`}>
        {pregunta.opciones.map((o) => {
          const marcada = marcadas.includes(o.codigo);
          return (
            <button
              key={o.codigo}
              type="button"
              role="radio"
              aria-checked={marcada}
              title={o.nombre !== o.corto ? o.nombre : undefined}
              className={`${classes.opcionPildora} ${marcada ? classes.opcionPildoraMarcada : ""}`}
              onClick={() => marcar(o.codigo)}
            >
              {o.corto}
            </button>
          );
        })}
      </div>
    </div>
  );
}
